import React from 'react';
import { BdsGrid, BdsTypo } from 'blip-ds/dist/blip-ds-react';
import { Subtitle } from './styles';

interface ModalHeaderProps {
  title: string;
  subtitle: string;
}

export const ModalHeader: React.FC<ModalHeaderProps> = ({ title, subtitle }) => {
  return (
    <BdsGrid direction="column" gap="half">
      <BdsTypo variant="fs-20" bold="bold" margin={false}>
        {title}
      </BdsTypo>
      <Subtitle>
        <BdsTypo variant="fs-14">{subtitle}</BdsTypo>
      </Subtitle>
    </BdsGrid>
  );
};
